<script setup lang="ts">
/**
 * Compact credit/debit pill. Credit = success-tone, debit = warning-tone.
 * Used in both the table row and the detail header.
 */
import { computed } from 'vue'
import StatusBadge from '@uiKit/components/StatusBadge.vue'
import { FIAT_TRANSACTION_TYPE, type FiatTransactionType } from '../types/fiatTransactionsTypes'
import { transactionTypeLabel } from '../utils/fiatTransactionLabels'

const props = defineProps<{
  type: FiatTransactionType
}>()

const color = computed(() => (props.type === FIAT_TRANSACTION_TYPE.CREDIT ? 'success' : 'warning'))
const label = computed(() => transactionTypeLabel(props.type))
</script>

<template>
  <StatusBadge :color="color" :label="label" />
</template>
